export const DISPLAY_HEADER_IN_DESKTOP = [
  'cabinet',
  'payout',
  'Invoicing',
  'InvoicingResult',
  'cardSelect',
  'card.binding',
  'editProject',
  'cardBindingMessage',
  'receipt',
  'transactionDeclaration',
  'selfEmployed',
  'projects',
  'partners',
  'notifications',
  'subscriptions',
  'Widgets',
  'profileTwoFactor',
  'profile',
  'identity',
  'timezone',
  'payment.settings.form',
  'payment.settings.method',
  'payment.settings.technical',
  'streamer.widgets.goal',
  'streamer.widgets.goal.form',
  'streamer.widgets.notification',
  'streamer.widgets.message',
  'streamer.widgets.donors',
  'streamer.widgets.ready',
  'report.main',
  'report.template',
  'ticket.code',
  'wallet.binding',
  'wallet.select',
  'card.sms',
];

export const DISPLAY_HEADER_IN_MOBILE = [
  'cabinet',
  'projects',
  'partners',
  'ticket.code',
];
